import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b36d25a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0b36d25a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b36d25a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b36d25a')) {
      api.createRecord('0b36d25a', component.options)
    } else {
      api.reload('0b36d25a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b36d25a&scoped=true", function () {
      api.rerender('0b36d25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen/attr/index.vue"
export default component.exports